import * as React from "react";
import { cn } from "../../lib/utils";

interface DropdownOption {
  value: string;
  label: string;
}

interface DropdownProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options: DropdownOption[];
}

export function Dropdown({ options, className, ...props }: DropdownProps) {
  return (
    <select className={cn("dropdown", className)} {...props}>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
